import React, { Fragment, useState } from "react"
import Error from "./Error"

const Pregunta = ({setRestante, setPresupuesto, setMostrarPregunta}) => {

    const [cantidad, setCantidad] = useState(0)
    
    const [error, setError] =  useState(false)


    const definirPresupuesto = (e) => {
        setCantidad(parseInt(e.target.value, 10))
    }

    const agregarPresupuesto = (e) => {
        e.preventDefault()

        if(cantidad < 1 || isNaN(cantidad)) {
            setError(true)
            return;
        }

        setError(false)
        setPresupuesto(cantidad)
        setRestante(cantidad)
        setMostrarPregunta(false)

    }


    return (
        <Fragment>
            <h2>Coloque su presupuesto</h2>

            { error ? <Error mensaje="El presupuesto no es válido" /> : null }

            <form
                onSubmit={agregarPresupuesto}
            >
                <input 
                    type="number"
                    placeholder="Coloque su presupuesto"
                    className="u-full-width"
                    onChange={definirPresupuesto}
                />
                <input type="submit" 
                    className="button-primary u-full-width"
                    value="Definir presupuesto"
                />
            </form>
        </Fragment>
    )
}

export default Pregunta